import Vue from 'vue';
import './_searchModule.js';
import './_priceListModule.js';
import './_findRightTreatmentModule.js';
import './_minaSidorModule.js';

import vueSmoothScroll from 'vue-smoothscroll';

import store from './store/store';

import BookingModule from './components/BookingModule.vue';
import BookingModuleActivity from './components/BookingModuleActivity.vue';
import ClinicsModule from './components/ClinicsModule.vue';

import moment from 'moment';
moment.locale('sv');

if (document.getElementById('book-time-main-wrapper')) {
  new Vue({
    el: '#book-time-main-wrapper',
    render: (h) => h(BookingModule),
    components: {},
    store,
  });
  Vue.use(vueSmoothScroll);
}

if (document.getElementById('book-time-activity-wrapper')) {
  new Vue({
    el: '#book-time-activity-wrapper',
    render: (h) => h(BookingModuleActivity),
    components: {},
    store,
  });
  Vue.use(vueSmoothScroll);
}

// Initialize Clinics Module
if (document.getElementById('clinics-module-wrapper')) {
  new Vue({
    el: '#clinics-module-wrapper',
    render: (h) => h(ClinicsModule),
    components: {},
    store,
  });
  Vue.use(vueSmoothScroll);
}
